import { ModalStatus, StatusTooltip } from "../DetailsModal/styled";
import { statusDescriptions } from "../statusColors";
import * as Styled from "./styled";
import ExclamationCircle from "@assets/icons/icon-changed.svg?react";
import type { RoadmapItemStatus } from "@/services/api/types";
import IntroPanel from "@/components/shared-ui/IntroPanel";

const RoadmapIntroduction = () => {
  return (
    <IntroPanel>
      <Styled.IntroSection>
        <Styled.Heading>Product roadmap</Styled.Heading>
        <p>
          Our roadmap shows what we’re delivering this quarter, alongside
          longer-term priorities and ongoing improvements.
        </p>
      </Styled.IntroSection>
      <Styled.IntroSection>
        <Styled.IconKey>
          <Styled.IconKeyRow>
            <Styled.IconContainer>
              <ExclamationCircle />
            </Styled.IconContainer>
            <p>
              Details have changed. Click on the card to see what's changed and
              why
            </p>
          </Styled.IconKeyRow>
          <Styled.StatusLegend>
            {Object.entries(statusDescriptions).map(([status, description]) => (
              <ModalStatus $status={status as RoadmapItemStatus} key={status}>
                {status
                  .split("_")
                  .join(" ")
                  .replace(/^\w/, (char) => char.toUpperCase())}
                <StatusTooltip>{description}</StatusTooltip>
              </ModalStatus>
            ))}
          </Styled.StatusLegend>
        </Styled.IconKey>
      </Styled.IntroSection>
    </IntroPanel>
  );
};

export default RoadmapIntroduction;
